import { Fetch } from 'lib/Fetch';

export function userWallet() {
  return new Fetch()
    .url('/user/login/wallet')
    .method('get')
    .userToken()
    .send();
}
